function calculateColumnWidth(screenWidth: number, lengthOfArray: number):number {
  let x = screenWidth / lengthOfArray;
  if (x > 30) {
    return 20;
  } else if (x < 15) {
    return 5;
  } else {
    return x - 10;
  }
}

function getRandomArray (max:number, min:number, length:number):number[] {
  let arr = Array(length).fill(0);
  arr.forEach((item, index) => {
    arr[index] = Math.floor(Math.random() * (max - min)) + min;
  });
  return arr;
}

function getArray (max:number, min:number, arr:number[]):number[] {
  let arrCopy = arr.slice()
  let maxArr = Math.max.apply(Math, arr);
  let mult = Math.floor(max / maxArr);
  arrCopy.forEach((item, index) => {
    arrCopy[index] = (arrCopy[index] * mult) + min;
  });
  return arrCopy;
}

export {
  calculateColumnWidth,
  getRandomArray,
  getArray
}